<template>
  <ValidationObserver>
    <div class="form-group">
      <label for="company.title">{{ $t('title') }}</label>
      <ValidationProvider name="title" vid="company.title" v-slot="{ errors }">
        <input class="form-control" v-model="company.title" :class="{ 'is-invalid': errors[0] }">
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label for="company.address">{{ $t('address') }}</label>
      <ValidationProvider name="address" vid="company.address" v-slot="{ errors }">
        <input class="form-control" v-model="company.address" :class="{ 'is-invalid': errors[0] }">
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label for="company.city">{{ $t('post') }}</label>
      <ValidationProvider name="city" vid="company.city" v-slot="{ errors }">
        <input class="form-control" v-model="company.city" :class="{ 'is-invalid': errors[0] }">
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label for="company.country">{{ $t('country') }}</label>
      <ValidationProvider name="country" vid="company.country" v-slot="{ errors }">
        <select class="form-control" v-model="company.country" :class="{ 'is-invalid': errors[0] }">
          <option v-for="country in countries" v-bind:value="country.code">{{country.name}}</option>
        </select>
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>
    <div class="form-group">
      <label for="company.vat">{{ $t('vat') }}</label>
      <ValidationProvider name="VAT number" vid="company.vat" v-slot="{ errors }">
        <input class="form-control" v-model="company.vat" :class="{ 'is-invalid': errors[0] }">
        <span class="text-danger">{{errors[0]}}</span>
      </ValidationProvider>
    </div>
  </ValidationObserver>
</template>

<script>
const moment = require('moment');
const countryList = require('country-list');

export default {
  name: 'Company',
  props: ['company'],
  data: () => ({
    countries: countryList.getData().sort((a, b) => a.name >= b.name ? 1 : -1),
  })
}
</script>

<i18n>
{
  "en": {
    "title": "Title",
    "address": "Address",
    "post": "Post",
    "country": "Country",
    "vat": "VAT number"
  },
  "sl": {
    "title": "Naziv",
    "address": "Naslov",
    "post": "Pošta",
    "country": "Država",
    "vat": "Davčna številka"
  }
}
</i18n>
